import { render } from "./EditClientAffecter.vue?vue&type=template&id=23187a36&ts=true"
import script from "./EditClientAffecter.vue?vue&type=script&lang=ts"
export * from "./EditClientAffecter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__